var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataInTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 184,
    viewBox: "0 0 236 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14818_573131)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.349 1.56924C50.0125 -11.7507 27.5249 63.1775 46.1723 99.6476C56.9868 120.797 5.6547 172.012 64.3079 182.926C92.4545 188.162 101.104 169.288 128.121 172.034C164.303 175.714 279.563 167.199 218.423 91.3655C186.009 51.1562 219.472 10.0925 153.349 1.56924Z",
    fill: "#F5F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7884 139.544L58.1202 143.876L56.8218 138.377C53.1075 136.274 49.1803 134.573 45.1064 133.301L45.0218 139.062L42.4207 132.527C37.866 131.313 33.177 130.677 28.4637 130.632L29.1827 136.947L25.7527 130.704C21.5102 130.891 17.3147 131.671 13.2887 133.022L15.6698 136.626C15.6698 136.626 13.4494 134.993 11.4954 133.665C7.49707 135.226 3.76259 137.393 0.422852 140.09C4.35254 144.08 8.65671 147.684 13.276 150.851C15.8136 150.199 18.5162 149.544 18.5162 149.544L15.1834 152.137C19.4427 154.958 23.9946 157.311 28.7598 159.154C31.1578 157.771 34.296 155.812 34.296 155.812L30.663 159.831C35.7312 161.611 41.0872 162.428 46.4555 162.242L50.8076 157.936L49.0735 162.026C56.2297 161.159 63.5296 158.037 70.4869 151.451C68.829 147.496 64.5912 143.199 58.7884 139.544Z",
    fill: "#9BDEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.422852 140.09L70.4869 151.456",
    stroke: "white",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.189 128.377H88.1408C85.3282 128.377 82.6426 126.092 82.6426 123.28V28.1452C82.6426 25.3323 85.3452 23.0693 88.1408 23.0693H178.189C181.001 23.0693 183.708 25.3492 183.708 28.1452V123.28C183.708 126.092 181.018 128.377 178.189 128.377Z",
    fill: "#9BDEFF",
    stroke: "#1D1E26",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14818_573131",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 22,
    width: 103,
    height: 107
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.189 128.377H88.1408C85.3282 128.377 82.6426 126.092 82.6426 123.28V28.1452C82.6426 25.3323 85.3452 23.0693 88.1408 23.0693H178.189C181.001 23.0693 183.708 25.3492 183.708 28.1452V123.28C183.708 126.092 181.018 128.377 178.189 128.377Z",
    fill: "#9BDEFF",
    stroke: "#1D1E26",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14818_573131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.0967 101.75L123.101 153.355",
    stroke: "white",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0322 29.418L139.038 163.505",
    stroke: "white",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6123 121.207L144.913 7",
    stroke: "white",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.531 61.9893L123.102 163.506",
    stroke: "white",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.657 44.6465L60.6123 138.55",
    stroke: "white",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7451 12.0762L225.854 134.743",
    stroke: "white",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.171 163.506L76.5488 3.19336",
    stroke: "white",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.135 0.655273L201.532 85.253",
    stroke: "white",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5801 77.2168L228.789 149.125",
    stroke: "white",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.105 9.53809L102.551 191.423",
    stroke: "white",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.189 128.377H88.1408C85.3282 128.377 82.6426 126.092 82.6426 123.28V28.1452C82.6426 25.3323 85.3452 23.0693 88.1408 23.0693H178.189C181.001 23.0693 183.708 25.3492 183.708 28.1452V123.28C183.708 126.092 181.018 128.377 178.189 128.377Z",
    stroke: "#1D1E26",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.708 31.5127H82.626V27.7058C82.626 26.3596 83.1607 25.0685 84.1125 24.1166C85.0643 23.1647 86.3552 22.6299 87.7012 22.6299H178.612C179.28 22.6271 179.943 22.7564 180.561 23.0102C181.179 23.2641 181.741 23.6375 182.214 24.1091C182.688 24.5807 183.064 25.1412 183.32 25.7584C183.576 26.3757 183.708 27.0374 183.708 27.7058V31.5127Z",
    fill: "white",
    stroke: "#1D1E26",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6904 28.8441C89.7065 28.8441 90.5302 28.0203 90.5302 27.0041C90.5302 25.9879 89.7065 25.1641 88.6904 25.1641C87.6743 25.1641 86.8506 25.9879 86.8506 27.0041C86.8506 28.0203 87.6743 28.8441 88.6904 28.8441Z",
    fill: "#1D1E26"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1015 28.8441C96.1176 28.8441 96.9413 28.0203 96.9413 27.0041C96.9413 25.9879 96.1176 25.1641 95.1015 25.1641C94.0854 25.1641 93.2617 25.9879 93.2617 27.0041C93.2617 28.0203 94.0854 28.8441 95.1015 28.8441Z",
    fill: "#1D1E26"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.51 28.8441C102.526 28.8441 103.349 28.0203 103.349 27.0041C103.349 25.9879 102.526 25.1641 101.51 25.1641C100.494 25.1641 99.6699 25.9879 99.6699 27.0041C99.6699 28.0203 100.494 28.8441 101.51 28.8441Z",
    fill: "#1D1E26"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 48.8682H64.4558C61.6411 48.8682 59.3594 51.1502 59.3594 53.9652V149.095C59.3594 151.91 61.6411 154.192 64.4558 154.192H154.5C157.314 154.192 159.596 151.91 159.596 149.095V53.9652C159.596 51.1502 157.314 48.8682 154.5 48.8682Z",
    fill: "white",
    stroke: "#1D1E26",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M160.019 57.3271H58.9365V53.5202C58.9421 52.1721 59.4815 50.881 60.4367 49.9297C61.3918 48.9784 62.6849 48.4443 64.0329 48.4443H154.923C156.27 48.4454 157.563 48.9799 158.518 49.931C159.472 50.882 160.012 52.1724 160.019 53.5202V57.3271Z",
    fill: "#008ACE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4286 54.6624C66.4447 54.6624 67.2684 53.8386 67.2684 52.8224C67.2684 51.8062 66.4447 50.9824 65.4286 50.9824C64.4126 50.9824 63.5889 51.8062 63.5889 52.8224C63.5889 53.8386 64.4126 54.6624 65.4286 54.6624Z",
    fill: "#1D1E26"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8359 54.6624C72.852 54.6624 73.6757 53.8386 73.6757 52.8224C73.6757 51.8062 72.852 50.9824 71.8359 50.9824C70.8198 50.9824 69.9961 51.8062 69.9961 52.8224C69.9961 53.8386 70.8198 54.6624 71.8359 54.6624Z",
    fill: "#1D1E26"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2441 54.6624C79.2602 54.6624 80.0839 53.8386 80.0839 52.8224C80.0839 51.8062 79.2602 50.9824 78.2441 50.9824C77.228 50.9824 76.4043 51.8062 76.4043 52.8224C76.4043 53.8386 77.228 54.6624 78.2441 54.6624Z",
    fill: "#1D1E26"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7754 37.1768L56.9357 44.7906",
    stroke: "#1D1E26",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8428 45.2129L54.2503 48.3853",
    stroke: "#1D1E26",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M184.343 16.7288L187.303 9.96094",
    stroke: "#1D1E26",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M187.303 18.8445L195.762 10.3848",
    stroke: "#1D1E26",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M189.418 22.2284L195.762 19.6904",
    stroke: "#1D1E26",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M186.457 56.4902V116.132",
    stroke: "#1D1E26",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M135.755 161.455C159.464 161.455 178.684 142.233 178.684 118.521C178.684 94.8098 159.464 75.5879 135.755 75.5879C112.047 75.5879 92.8271 94.8098 92.8271 118.521C92.8271 142.233 112.047 161.455 135.755 161.455Z",
    fill: "#008ACE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M135.755 152.995C154.792 152.995 170.224 137.561 170.224 118.521C170.224 99.4822 154.792 84.0479 135.755 84.0479C116.718 84.0479 101.285 99.4822 101.285 118.521C101.285 137.561 116.718 152.995 135.755 152.995Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M119.34 116.09C121.489 116.09 123.231 114.347 123.231 112.198C123.231 110.049 121.489 108.307 119.34 108.307C117.191 108.307 115.449 110.049 115.449 112.198C115.449 114.347 117.191 116.09 119.34 116.09Z",
    fill: "#1D1E26"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M152.173 116.09C154.322 116.09 156.064 114.347 156.064 112.198C156.064 110.049 154.322 108.307 152.173 108.307C150.024 108.307 148.282 110.049 148.282 112.198C148.282 114.347 150.024 116.09 152.173 116.09Z",
    fill: "#1D1E26"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M124.344 131.808C126.497 128.301 130.802 125.86 135.763 125.86C140.724 125.86 145.068 128.276 147.182 131.808",
    stroke: "#1D1E26",
    strokeWidth: 1.69176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M174.181 140.408L166.186 150.402L167.89 151.766L175.885 141.771L174.181 140.408Z",
    fill: "#1D1E26"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M204.647 166.975C205.239 169.166 201.242 173.979 198.971 174.068C191.781 174.352 169.606 149.624 169.606 149.624L174.145 143.947C174.145 143.947 202.888 160.448 204.647 166.975Z",
    fill: "#9BDEFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M208.378 182.342C211.891 182.342 214.739 179.493 214.739 175.98C214.739 172.466 211.891 169.618 208.378 169.618C204.865 169.618 202.017 172.466 202.017 175.98C202.017 179.493 204.865 182.342 208.378 182.342Z",
    fill: "#9BDEFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203.433 172.008C204.293 170.932 205.482 170.167 206.817 169.83L204.647 168.096C204.174 170.211 201.623 173.201 199.703 173.912L202.05 175.79C202.086 174.412 202.572 173.084 203.433 172.008Z",
    fill: "#1D1E26"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3924 141.388L69.8143 144.408L72.5972 138.973C71.0118 134.512 68.9709 130.227 66.5069 126.186L62.4044 130.8L64.8363 123.567C61.9437 119.216 58.5355 115.231 54.6858 111.698L50.8793 117.371L52.4527 109.757C48.8445 106.78 44.8458 104.31 40.5681 102.418L39.9886 107.126C39.9886 107.126 39.2993 104.165 38.6268 101.627C34.2684 99.9488 29.6782 98.9502 25.0166 98.666C25.4602 104.832 26.4811 110.943 28.066 116.918C30.6036 118.259 33.2977 119.731 33.2977 119.731L28.7385 119.376C30.2607 124.82 32.3472 130.091 34.9641 135.102C37.9247 135.754 41.858 136.485 41.858 136.485L36.0553 137.048C38.9905 142.124 42.6912 146.861 47.3689 150.694L53.9625 150.419L49.6782 152.453C56.1745 157.043 64.3668 159.915 74.6992 159.716C76.1288 155.287 75.6213 148.659 73.3924 141.388Z",
    fill: "#008ACE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9785 98.6494L74.6992 159.729",
    stroke: "white",
    strokeWidth: 0.845878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14818_573131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 184,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataInTable);
export default __webpack_public_path__ + "static/media/no-data-in-table.23bc56f9629559a237d3592aaedc82ea.svg";
export { ForwardRef as ReactComponent };